import { useEffect, useState } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useCurrentUserProfile = () => {
  const [profile, setProfile] = useState(null);
  const token = localStorage.getItem("access_token");

  const fetchProfile = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/user/profile/create-profile/`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );

      if (!res.ok) {
        console.error("Failed to fetch profile:", res.status);
        return;
      }

      const data = await res.json();
      setProfile(data?.data || null);
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [token]);

  return { profile, fetchProfile };
};

export default useCurrentUserProfile;